/* global axios */
import ApiClient from '../ApiClient';

class WgptTasksAPI extends ApiClient {
  constructor() {
    super('tasks', {
      accountScoped: true,
      wgpt: true,
    });
  }

  addFile(taskId, data) {
    return axios.post(`${this.url}/${taskId}/files`, data);
  }
}

export default new WgptTasksAPI();
